import master from "./dummyData/masterData";
import categoryJson from "./dummyData/category_bbgt.json";
import {
  securedAxiosInstance
} from '../../../../../../backend/axios';
export default {


  namespaced: true,
  state: {
    category_master: [], // State to store category master data
    grade: {},
    resolution: {},
    rule: null,
    masterData: {},
    selected_option: {},
    selected_option_question: {},
    currentQuestionIndex: 1
  },
  mutations: {
    SET_CATEGORY_MASTER(state, categories) {
      state.category_master = categories;
    },
    selectRule(state, item) {
      state.rule = item;
    },
    updateSelectedGrade(state, item) {
      state.grade = item;
    },
    updateSelectedResolution(state, item) {
      state.resolution = item;
    },
    refreshMasterData(state, item) {
      console.log("refreshMasterData", item);
      state.masterData = item;
    },
    setSelectedOption(state, { option, question, currentQuestionIndex }) {
      state.selected_option = option;
      state.selected_option_question = question;
      state.currentQuestionIndex = currentQuestionIndex
    },
  },
  actions: {
    setSelectedOption({ commit }, { option, question, currentQuestionIndex }) {
      commit('setSelectedOption', { option, question, currentQuestionIndex });
    },
    refreshMasterData({ commit }) {
      console.log("refreshMasterData", master);
      commit('refreshMasterData', master);
    },

    async fetchCategoryMaster({ commit }) {
      try {
        securedAxiosInstance.get('api/v2/warehouse/liquidation/channel_allocations/formatted_category_list').then((response) => {
          console.log("Response::::::::::::::::: ", response);
          let flattenCategory
          if (response.data.category_list) {
            flattenCategory = flattenCategories(response.data.category_list);
            flattenCategory.unshift({
              text: "All",
              value: "All"
            });
          } else {
            flattenCategory = flattenCategories(categoryJson);
          }
          commit('SET_CATEGORY_MASTER', flattenCategory);
        }, error => {
          console.log("error", error);
          let flattenCategory = flattenCategories(categoryJson);
          console.log("flattenCategories", flattenCategory);
          commit('SET_CATEGORY_MASTER', flattenCategory);
        });

      } catch (error) {
        console.error('Error fetching category master:', error);
      }
    },

    updateSelectedGrade({ commit }, item) {
      commit('updateSelectedGrade', item);
    },
    updateSelectedResolution({ commit }, item) {
      console.log(item);
      commit('updateSelectedResolution', item);
    },
    async saveSelectedResolution({ commit }, item) {
      let url = '/api/v2/rule_engine/create_rule';
      if (item.id) {
        url = '/api/v2/rule_engine/update_rule';
      }
      if (item.rules && item.rules.grade_rules && item.rules.grade_rules.length > 0) {
        item.status = "Completed";
      } else {
        item.status = "Pending";
      }

      item.article_id = item.article_id ?? null;
      item.profile_name = item.profile_name ?? null;
      item.brand = item.brand ?? "All";
      item.sku = item.sku ?? "All";
      item.grade_type = item.grade_type ?? "FTA Service Request";
      item.type_of_item = item.type_of_item ?? "All";


      let response = await securedAxiosInstance.post(url, item)
      console.log("Resolution save response", response);
      commit('updateSelectedResolution', item);
    },
    async saveSelectedGrade({ commit }, item) {
      let url = '/api/v2/rule_engine/create_question';
      if (item.id) {
        url = '/api/v2/rule_engine/update_question';
      }
        item.article_id = item.article_id ?? null;
        item.profile_name = item.profile_name ?? null;
        item.brand = item.brand ?? "All";
        item.sku = item.sku ?? "All";
        item.grade_type = item.grade_type ?? "FTA Service Request";
        item.type_of_item = item.type_of_item ?? "All";
        item.rules = item.rules ?? {};
        item.rules.tests = item.rules.tests ?? {};
        
      for (let key in item.rules.tests) {
        item.rules.tests[key].index = item.rules.tests[key].index + "";
        if (item.rules.tests[key] && item.rules.tests[key].options && item.rules.tests[key].options.length > 0) {
          for (let option of item.rules.tests[key].options) {
            option.route = option.route + "";
          }
        }
      }

      if (item.rules && item.rules.tests) {
        let allSet = true;
        for (const test of Object.values(item.rules.tests)) {
          if (test.test_type && test.test_type != 'End' && (!test.options || test.options.some(option => !option.route))) {
            allSet = false // If any test has an option without a route
          }
        }
        if (allSet) {
          item.status = "Completed";
        } else {
          item.status = "Pending";
        }
      } else {
        item.status = "Pending";
      }
      let response = await securedAxiosInstance.post(url, item)
      console.log("Grade save response", response);
      commit('updateSelectedGrade', item);
    },
    async deleteSelectedResolution({ commit }, item) {
      item = { id: item + '' }
      let response = await securedAxiosInstance.post('/api/v2/rule_engine/delete_rule/', item)
      console.log("Delete Rule", response);
      commit('updateSelectedResolution');
    },
    async deleteSelectedProfile({ commit }, item) {
      item = { id: item + '' }
      let response = await securedAxiosInstance.post('/api/v2/rule_engine/delete_question/', item)
      console.log("Delete Profile", response);
      commit('updateSelectedGrade');
    },
    selectRule({ commit }, item) {
      commit('selectRule', item);
    },
  },
  getters: {
    categoryMaster: (state) => state.category_master,
  },
  methods: {
    // Utility method to flatten categories
    flattenCategories(categories, parentPath = "") {
      console.log("categories", categories, "parentPath", parentPath);
      let flatCategories = [];
      const categoriesArray = Array.isArray(categories) ? categories : [categories];
      categoriesArray.forEach((category) => {
        const fullPath = parentPath ? `${parentPath} / ${category.name}` : category.name;
        flatCategories.push({
          text: fullPath,
          value: category.id,
        });
        if (category.children && category.children.length) {
          flatCategories = flatCategories.concat(
            flattenCategories(category.children, fullPath)
          );
        }
      });
      return flatCategories;
    },
  },
};

function flattenCategories(categories, parentPath = '') {
  let flatCategories = [];
  const categoriesArray = Array.isArray(categories) ? categories : [categories];
  categoriesArray.forEach((category) => {
    const fullPath = parentPath ? `${parentPath} / ${category.name}` : category.name;
    flatCategories.push({
      text: fullPath,
      value: category.id,
    });
    if (category.children && category.children.length) {
      flatCategories = flatCategories.concat(
        flattenCategories(category.children, fullPath)
      );
    }
  });
  return flatCategories;
}